import { useTranslation } from 'react-i18next';
import { IconButton } from '@chakra-ui/react';

import { FeatherIcon, useModalStore } from '@izimi/components';

export const ShareDocument = () => {
  const { t } = useTranslation();
  const { showModal } = useModalStore();

  const onClick = () =>
    showModal({
      type: 'sendCommunication',
    });

  return (
    <IconButton
      backgroundColor='primary500'
      icon={<FeatherIcon name='send' color='white' />}
      aria-label={t('navigation.quickSend.title')}
      onClick={onClick}
    />
  );
};
